import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value;
    type;
    disabled;
    formData = {
        value: this.$props.value,
    };
    valueChange(val) {
        this.formData.value = val;
    }
    get computedMax() {
        return this.type === 'SECOND' ? 100000 : 9999;
    }
    get isShow() {
        return this.type === 'FREQUENCY' || this.type === 'SECOND';
    }
    changeValue(val) {
        this.$emit('update:value', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    get rules() {
        return {
            value: [
                { required: true, message: this.inputPlaceholder, trigger: 'blur' },
                { pattern: this.getPattern(), message: this.inputPlaceholder, trigger: 'blur' },
            ],
        };
    }
    getPattern() {
        let newTime = /^([1-9]|[1-9]\d|100)$/;
        switch (String(this.type)) {
            case 'FREQUENCY':
                newTime = /^([1-9]|[1-9]\d|[1-9]\d\d)$/;
                break;
            case 'SECOND':
                newTime = /^(([1-9][0-9]{0,4})|100000)$/;
                break;
            default:
                newTime = /^([1-9]|[1-9]\d|100)$/;
        }
        return newTime;
    }
    get inputPlaceholder() {
        if (this.type === 'FREQUENCY') {
            return this.$t('alarmInputRule');
        }
        else if (this.type === 'SECOND') {
            return this.$t('alarmInputRuleSecond');
        }
        else {
            return this.$t('thresholdInputRule');
        }
    }
    getType(type) {
        let newType = '';
        switch (type) {
            case 'FREQUENCY':
                newType = 'Min';
                break;
            case 'SECOND':
                newType = 'S';
                break;
            default:
                newType = '%';
        }
        return newType;
    }
    resetFields() {
        this.$refs.ruleForm.resetFields();
    }
};
__decorate([
    Prop()
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: 'FREQUENCY', type: String })
], default_1.prototype, "type", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "valueChange", null);
default_1 = __decorate([
    Component({
        name: 'FrequencyAndThreshold',
        components: {},
        i18n: {
            messages: {
                zh: {
                    alarmTitle: '告警频率',
                    thresholdTitle: '匹配度阈值',
                    rate: '（匹配比率）',
                    alarmInputRule: '请输入告警频率，1-999',
                    alarmInputRuleSecond: '请输入告警频率，1-100000',
                    thresholdInputRule: '请输入匹配度阈值，1-100',
                },
                en: {
                    alarmTitle: 'Alert Interval',
                    thresholdTitle: 'Threshold',
                    rate: '(matching rate)',
                    alarmInputRule: 'Please enter alart interval, 1-999',
                    alarmInputRuleSecond: 'Please enter alart interval, 1-100000',
                    thresholdInputRule: 'Please enter matching rate, 1-100',
                },
            },
        },
    })
], default_1);
export default default_1;
